const {
	trackGtm,
	trackGtm4,
	fillWithDomElements,
	disableStaticURL,
} = require('util/functions');
const CLASS_TITLE = 'document-download-partial--title';
const CLASS_LINK = 'document-download-partial--download';

const selectors = {
	title: CLASS_TITLE,
	link: CLASS_LINK,
};
module.exports = {
	init() {
		fillWithDomElements(this, selectors);

		this.root.addEventListener('click', ({ target }) => {
			const { href } = target;
			trackGtm4({
				event: 'GA4_event_c_file_download',
				file_name: href.split('/').pop(),
				widget_name: 'V3-Document',
				widget_title: this.title?.innerHTML,
				link_url: this.link?.href,
				link_text: this.link?.innerHTML,
				title: this.title?.innerHTML,
			});
			trackGtm({
				eventCategory: 'outgoing tracking',
				eventAction: 'download',
				eventLabel: `${this.title?.innerHTML} / ${this.link?.href}`,
			});
			disableStaticURL(target, 'download-disabled');
		});
	},
};
